module.exports = __webpack_public_path__ + "static/media/logo4.3fa103e1.png";